import { useState, useEffect } from "react";

export function useAsync<T>(operation: () => Promise<T>): AsyncResult<T> {
    const [result, setResult] = useState<AsyncResult<T>>({ status: "pending" });

    useEffect(() => {
        operation()
            .then((value) => setResult({ status: "resolved", value }))
            .catch((error) => setResult({ status: "rejected", error }));
    }, [operation]);

    return result;
}

export type AsyncResult<T> =
    | PendingAsyncResult
    | ResolvedAsyncResult<T>
    | RejectedAsyncResult;

export type ResolvedAsyncResult<T> = {
    readonly status: "resolved";
    readonly value: T;
};

export type RejectedAsyncResult = {
    readonly status: "rejected";
    readonly error: unknown;
};

export type PendingAsyncResult = {
    readonly status: "pending";
};
